import React from 'react'
import { connect } from 'react-redux'
import * as types from '../../constants/Types'
import PropTypes from 'prop-types'

class ReceiptLine extends React.Component {
  
  render() {
    const price = this.props.price.toFixed(2).toString().replace('.', ',');
    
    let configurationDescription = '';
    let i = 0;
    if (this.props.configuration) {
      this.props.configuration.map(conf => {
        if (conf.ParentConfigurationStepValueId <= 0) {
          if (i > 0) {
            configurationDescription = `${configurationDescription}, `;
          }
          configurationDescription = `${configurationDescription}${conf.ConfigurationStepValueDescription}`;
          i++;
        }
        return '';
      });
    }
    
    let lineStyle = {
    }

    var hideLineDetails = false;

    if (this.props.linetype === types.SUBTOTAL_LINE) {
      if (!this.props.simpleSeparator){
        lineStyle.borderBottom = '1px solid #475358'
        lineStyle.borderTop = '1px solid #475358'
        lineStyle.backgroundColor = '#CAD9DD';
      }
      else
      {
        lineStyle.borderBottom = '1px dashed #475358'
        hideLineDetails = true;
      }
    }

    let quantity = (<div className="quantity"></div>);
    if (this.props.linetype === types.ARTICLE_LINE) {
      quantity = `${this.props.quantity}x`
    }

    let discountStyle = {
      fontSize: '12px'
    }
    const discounts = [];
    if (this.props.discount !== null) {
      let id = 1;
      this.props.discount.map(d => {
        discounts.push({
          id: id,
          description: d.Description,
          price: d.Price.toFixed(2).replace('.', ',')
        });
        id++;
        return '';
      })
    }

    return (
      <div key={this.props.lineid} className="linewrapper" style={lineStyle}>
        <div key={this.props.lineid} ref="receiptline" className="receiptLine">
          <table className="contenttable">
            <tbody>
            <tr hidden={hideLineDetails}>
                <td className="quantity">{quantity}</td>
                <td className="description">
                  {this.props.description}&nbsp;
                    <label className="configurationDescription">{configurationDescription}</label>
                </td>
                <td className="price">
                  {price}
                </td>
              </tr>
              {discounts.map(d =>
                <tr key={d.id}>
                  <td className="quantity"></td>
                  <td><label style={discountStyle}>{d.description}</label></td>
                  <td className="price">{d.price}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

ReceiptLine.propTypes = {
  quantity: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  configuration: PropTypes.array,
  discount: PropTypes.array.isRequired,
  price: PropTypes.number.isRequired,
  lineid: PropTypes.number,
  itemid: PropTypes.number,
  linetype: PropTypes.number,
  editable: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  detailView: PropTypes.bool,
  simpleSeparator: PropTypes.bool
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, {
})(ReceiptLine)



// WEBPACK FOOTER //
// src/components/CustomerDisplay/ReceiptLine.jsx